import { BaseService } from '../../infra/base.service'
import type { BalanceResult } from './balance-result'
import type { BalanceResultsRepository } from './balance-results.repository'

export class BalanceResultsService extends BaseService<BalanceResult> {
    constructor(private rep: BalanceResultsRepository) {
        super(rep)
    }

    async recalcBalance(personIds: string[]) {
        return await this.rep.recalcBalance(personIds)
    }
}
